import { Column } from 'material-table';
// @ts-ignore
import { CsvBuilder } from 'filefy';

/**
 * Unfortunately, material-table doesn't allow hiding just the export PDF
 * button. This will make sure it is removed from the DOM when the export menu
 * is opened.
 */
export function hideMaterialTableExportPdf() {
  setTimeout(() => { // Wait until page load.
    new MutationObserver((mutations, observer) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((addedNode) => {
          if (addedNode.nodeType === Node.ELEMENT_NODE) {
            const element = addedNode as Element;
            if (element.classList.contains('MuiPopover-root')) {
              Array.from(
                element.getElementsByClassName('MuiMenuItem-root'),
              ).forEach((menuItem) => {
                if (menuItem.textContent === 'Export as PDF') {
                  menuItem.remove();
                }
              });
            }
          }
        });
      });
    }).observe(document.body, { childList: true });
  }, 0);
}

export interface CustomColumn<RowData extends object> extends Column<RowData> {
  exportTitle?: string;
}

/**
 * Custom exportCsv function. For now, it just enables specifying an export
 * title for a column which is different than its normal title.
 */
export function exportCsv(filename: string) {
  return (allColumns: Array<CustomColumn<any>>, allData: Array<any>) => {
    const columns = allColumns.filter((column) => column.export !== false);
    const exportedData = allData.map((rowData) =>
      columns.map((column) => (rowData as any)[column.field!]));
    new CsvBuilder(filename)
      .setDelimeter(',')
      .setColumns(columns.map((column) => column.exportTitle || column.title))
      .addRows(exportedData)
      .exportFile();
  };
}
